import * as React from "react";
const SvgFiBrandsGitlab = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-gitlab_svg__a)">
      <path
        fill="#151A2D"
        d="m23.93 13.344-1.281-3.945-2.541-7.824a.97.97 0 0 0-.934-.671h-.006a.97.97 0 0 0-.927.676l-2.417 7.442H8.18L5.759 1.58A.97.97 0 0 0 4.83.905h-.006a.975.975 0 0 0-.936.677L1.354 9.4.07 13.344c-.19.586.016 1.223.514 1.585l11.095 8.06a.55.55 0 0 0 .64 0l11.098-8.06c.497-.361.703-.998.513-1.585m-2.914-3.231-7.542 9.663 3.14-9.663zM12 20.788l-.273-.842-3.192-9.833h6.936zM7.389 10.113l3.137 9.663-7.537-9.663zM19.176 2.23l2.206 6.793h-4.413zm-14.351 0 2.21 6.793H2.622zm-3.6 11.818a.33.33 0 0 1-.12-.368l.969-2.97 1.409 1.806 5.71 7.32zm21.55 0-7.967 5.788 2.26-2.896 4.862-6.23.964 2.969a.33.33 0 0 1-.118.369"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-gitlab_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsGitlab;
